import { Controller } from '@hotwired/stimulus'
import { sendError } from '../utils'
import { patch } from '@rails/request.js'

export default class extends Controller {
  read(event) {
    if (!this.element.hasAttribute('data-unread')) {
      this.#click(event)
      return
    }

    patch(event.params.url)
      .then((response) => {
        if (response.ok) this.#markAsRead()
      })
      .catch((error) => {
        console.error(error)
        sendError(error, this.identifier, { url: event.params.url })
      })
      .finally(() => this.#click(event))
  }

  // Private

  #markAsRead() {
    this.element.removeAttribute('data-unread')
  }

  #click(event) {
    if (event.type == 'auxclick' || event.ctrlKey) {
      // respect users who want to open link to another tab
      window.open(this.element.href, '_blank', 'noopener')
    } else {
      this.element.click()
    }
  }
}
